import React from 'react';
import TableHeader from '../../../models/TableHeader';
import OrdenacaoColuna from '../../UI/Tabela/Ordenacao/OrdenacaoColuna';
import CheckboxField from '../../UI/Field/Checkbox/CheckboxField';

class TablePassoDoisFactory {
  makeCabecalhoTablePassoDois(
    setArrowOrdenacao,
    arrowOrdenacao,
    columnOrdenacao,
    setColumnOrdenacao,
    onClickOrdernacaoColumn,
    selectAll = { checked: false, onChange: () => { } },
  ) {
    return [
      new TableHeader({
        id: 'idTitulo',
        checkbox: true,
        label: (
          <CheckboxField
            checked={selectAll.checked}
            onChange={selectAll.onChange}
          />),
        width: 16,
      }),
      new TableHeader({
        id: 'sequencia',
        label: <OrdenacaoColuna
          columnLabel="Sequência"
          idColumn="sequencia"
          arrowOrdenacao={arrowOrdenacao}
          columnOrdenacao={columnOrdenacao}
          setArrowOrdenacaoFunc={setArrowOrdenacao}
          setColumnOrdenacao={setColumnOrdenacao}
          onClickColumn={() => onClickOrdernacaoColumn('sequencia')}
        />,
        alignCell: 'center',
        maxWidth: 90,
      }),
      new TableHeader({
        id: 'idTipoTitulo',
        label: 'Tipo',
        alignCell: 'center',
        maxWidth: 90,
      }),
      new TableHeader({
        id: 'numero',
        label: 'Número',
        alignCell: 'center',
        maxWidth: 154,
      }),
      new TableHeader({
        id: 'dataVencimento',
        label: <OrdenacaoColuna
          columnLabel="Vencimento"
          idColumn="dataVencimento"
          arrowOrdenacao={arrowOrdenacao}
          columnOrdenacao={columnOrdenacao}
          setArrowOrdenacaoFunc={setArrowOrdenacao}
          setColumnOrdenacao={setColumnOrdenacao}
          onClickColumn={() => onClickOrdernacaoColumn('dataVencimento')}
        />,
        maxWidth: 117,
        alignCell: 'center',
      }),
      new TableHeader({
        id: 'atraso',
        label: <OrdenacaoColuna
          columnLabel="Atraso"
          idColumn="atraso"
          arrowOrdenacao={arrowOrdenacao}
          columnOrdenacao={columnOrdenacao}
          setArrowOrdenacaoFunc={setArrowOrdenacao}
          setColumnOrdenacao={setColumnOrdenacao}
          onClickColumn={() => onClickOrdernacaoColumn('atraso')}
        />,
        maxWidth: 117,
        alignCell: 'center',
      }),
      new TableHeader({
        id: 'valorOriginal',
        label: 'Valor Original',
        alignCell: 'right',
        maxWidth: 154,
      }),
      new TableHeader({
        id: 'valorSaldoOriginal',
        label: <OrdenacaoColuna
          columnLabel="Saldo do Original"
          idColumn="valorSaldoOriginal"
          arrowOrdenacao={arrowOrdenacao}
          columnOrdenacao={columnOrdenacao}
          setArrowOrdenacaoFunc={setArrowOrdenacao}
          setColumnOrdenacao={setColumnOrdenacao}
          onClickColumn={() => onClickOrdernacaoColumn('valorSaldoOriginal')}
        />,
        alignCell: 'right',
        maxWidth: 154,
      }),
    ];
  }
}


export const tablePassoDoisFactory = new TablePassoDoisFactory();
